// Метки кампании переживают редирект гостя на /auth (/plans?utm_source=vk → /auth?utm_source=vk):
// Метрика успевает получить хит до редиректа, а GA4 и Amplitude стартуют позже и видят уже
// новый адрес. Переносим только белый список — секреты из адреса (?token=, ?ticket=) и любые
// другие параметры дальше не идут.
const CAMPAIGN_PARAM = /^(?:utm_[a-z0-9_]+|yclid|gclid)$/;

/** Query-строка («?utm_source=vk») только с метками кампании; '' — если меток нет. */
export function campaignSearch(search: string): string {
  const kept = new URLSearchParams();
  new URLSearchParams(search).forEach((value, key) => {
    if (CAMPAIGN_PARAM.test(key)) kept.append(key, value);
  });
  const query = kept.toString();
  return query ? `?${query}` : '';
}
